import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import './app/config/moment.config';
import { AppModule } from './app/app.module';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
